import { getInjector } from '../utils/getInjector';

/**
 * @param {number} count
 */
export const onCartItemCountUpdate = async (count) => {
  const injector = await getInjector();
  const $rootScope = injector.get('$rootScope');

  $rootScope.$broadcast('cartItemCountUpdated', count);
};
